import { render, staticRenderFns } from "./profile-photos.vue?vue&type=template&id=aa2c2946&scoped=true&"
import script from "./profile-photos.vue?vue&type=script&lang=js&"
export * from "./profile-photos.vue?vue&type=script&lang=js&"
import style0 from "./profile-photos.vue?vue&type=style&index=0&id=aa2c2946&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2c2946",
  null
  
)

export default component.exports